import { HistoryItem as HistoryItemType, HistoryType } from "../types";
import HistoryItem from "./HistoryItem";

type HistoryGroupProps = {
  histories: HistoryItemType[];
  onClick: (history: HistoryItemType) => void;
  onDelete: (history: HistoryItemType) => void;
  onSave: (history: HistoryItemType) => void;
  label?: string;
};

function HistoryGroup({
  histories,
  onClick,
  onDelete,
  onSave,
  label,
}: HistoryGroupProps) {
  if (histories.length === 0) {
    return null;
  }

  return (
    <div className="overflow-hidden w-full">
      {label && <h2 className="px-4 mb-1 tiny-md text-fg-muted">{label}</h2>}
      <ol className="overflow-hidden w-full">
        {histories.map((history) => (
          <HistoryItem
            key={
              history.type === HistoryType.Thread
                ? history.thread_id
                : history.id
            }
            onDelete={onDelete}
            onClick={onClick}
            onSave={onSave}
            history={history}
          />
        ))}
      </ol>
    </div>
  );
}

export default HistoryGroup;
